import React from "react";
import ContentLoader from "react-content-loader";
import useDevice from "../../hooks/useDevice";
import CardSkeleton from "../Skeleton/CardSkeleton";

const SingleProductLoader = (props) => {
  const { isMobile } = useDevice();

  return isMobile ? (
    <CardSkeleton height={400} width={300} />
  ) : (
    <ContentLoader
      viewBox="0 0 1000 600"
      height={600}
      width="100%"
      backgroundColor="#2b2b2b"
      foregroundColor="#3a3a3a"
      {...props}
    >
      <rect x="80" y="50" rx="8" ry="8" width="280" height="420" />

      <rect x="420" y="60" rx="6" ry="6" width="400" height="28" />

      <rect x="420" y="110" rx="4" ry="4" width="250" height="18" />

      <rect x="420" y="150" rx="4" ry="4" width="150" height="20" />

      <rect x="420" y="190" rx="4" ry="4" width="500" height="14" />
      <rect x="420" y="215" rx="4" ry="4" width="480" height="14" />
      <rect x="420" y="240" rx="4" ry="4" width="460" height="14" />

      <rect x="420" y="290" rx="20" ry="20" width="120" height="40" />

      <circle cx="580" cy="310" r="18" />
      <circle cx="630" cy="310" r="18" />
      <circle cx="680" cy="310" r="18" />
      <circle cx="730" cy="310" r="18" />
    </ContentLoader>
  );
};

export default SingleProductLoader;
